import React, { useState } from 'react';
import { AritoIcon, BottomActionBarV2, DialogV2, AritoFormV2 } from '@/components/custom/erp';
import { ChiPhiMuaHang, ChiPhiMuaHangInput } from '@/types/schemas/chi-phi-mua-hang.type';
import { chiPhiMuaHangSchema, initialValues, type FormValues } from '../schema';
import { ChungTu } from '@/types/schemas';
import { BasicInfo } from './BasicInfo';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ChiPhiMuaHangInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: ChiPhiMuaHang | null;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

export const FormDialog: React.FC<FormDialogProps> = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy
}) => {
  const [chungTu, setChungTu] = useState<ChungTu | null>(initialData?.ma_ct_data || null);

  const handleSubmit = async (data: FormValues) => {
    try {
      const input = {
        ...data,
        ma_ct: chungTu?.uuid
      } as ChiPhiMuaHangInput;
      onSubmit(input);
    } catch (err: unknown) {
      console.error('Error in handleSubmit:', err);
    }
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={'Chi phí mua hàng'}
      maxWidth='md'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={699} />}
    >
      <AritoFormV2<FormValues>
        onClose={onClose}
        mode={formMode}
        schema={chiPhiMuaHangSchema}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa chi phí mua hàng' : 'Xem chi phí mua hàng'}
        initialData={initialData || initialValues}
        onSubmit={handleSubmit}
        className='w-full min-w-[800px]'
        headerFields={<BasicInfo formMode={formMode} chungTu={chungTu} setMaCt={setChungTu} />}
        hasAritoActionBar={false}
        bottomBar={
          <BottomActionBarV2
            mode={formMode}
            onAdd={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}
            onCopy={onCopy}
            onClose={onClose}
          />
        }
      />
    </DialogV2>
  );
};

export default FormDialog;
